// extracted by mini-css-extract-plugin
export var completeMarkFailed = "complete-mark__failed_ib7JexLndmzDK_APexkv";
export var completeMarkSuccess = "complete-mark__success_kNoqs7knxmIyHRe3JLxw";